import { defer, Observable } from 'rxjs';
import { ElementRef } from '@angular/core';
import { finalize } from 'rxjs/operators';

function prepare<T>(callback: (source: Observable<T>) => Observable<T>): (source: Observable<T>) => Observable<T> {
    return (source: Observable<T>): Observable<T> => defer(() => callback(source));
}

function setDisabled(htmlElement: HTMLElement, disabled: boolean): boolean {
    if ('disabled' in htmlElement) {
        const wasDisabled = (htmlElement as any).disabled;
        (htmlElement as any).disabled = disabled;
        return wasDisabled;
    }
    return false;
}

export function loadingAll<T>(...elements: (ElementRef<HTMLElement> | HTMLElement)[]): (source: Observable<T>) => Observable<T> {
    return (source: Observable<T>): Observable<T> => {
        for (const element of elements) {
            source = source.pipe(loading(element));
        }
        return source;
    };
}

export function loading<T>(element: ElementRef<HTMLElement> | HTMLElement): (source: Observable<T>) => Observable<T> {
    const htmlElement: HTMLElement = element instanceof ElementRef ? element.nativeElement : element;
    if (!htmlElement) {
        return source => source;
    }
    return (source: Observable<T>): Observable<T> =>
        source.pipe(
            prepare(obs => {
                const timeout = setTimeout(() => htmlElement.classList.add('is-loading'), 200);

                const wasDisabled = setDisabled(htmlElement, true);

                return obs.pipe(
                    finalize(() => {
                        clearTimeout(timeout);
                        htmlElement.classList.remove('is-loading');
                        if (!wasDisabled) {
                            setDisabled(htmlElement, false);
                        }
                    })
                );
            })
        );
}
